import { TPage } from '@/types';
import { Logo, Typography } from '@data-products-and-ai/react-components';
const returnTeam = (team: string) => {
  if (team === 'red') return ' under where people hang their coats!';
  if (team === 'green') return ' where you go if you need to put out a fire!';
  if (team === 'blue') return ' behind where we project our slides!';
  if (team === 'yellow') return ' behind where we write our ideas!';
  return null;
};
const OriginalRoom = ({ team }: Partial<TPage>) => {
  if (!team) return null;
  return (
    <>
      <div style={{ padding: 20, textAlign: 'center' }}>
        <Logo />
      </div>
      <div style={{ textAlign: 'center', padding: 20 }}>
        {/*  {team === 'blue' && (
        <div style={{ marginBottom: 20 }}>
          <img src={table} alt="" style={{ width: 200, height: 'auto' }} />
        </div>
      )} */}
        <Typography tag="h4">
          You are getting close to the end!
          <br />
          <br />
          Quickly go to the workshop room where we started the day and find the
          next clue {returnTeam(team)}
        </Typography>
      </div>
    </>

    /*   <Lock
      target={target}
      lockType="image"
      combination="3,0,2,1,4,5,7,6,9,8"
      text={
        <Typography tag="h1">
          Great job so fAr but aRe you All aGain prEpared? Go aROUND the message
          and Find aLl yOu need tO be in the Right path!
        </Typography>
      }
    /> */
  );
};

export default OriginalRoom;
